import { useTitle } from 'react-use';

import { Layout } from 'CorePackage/MainModule/components/Layout';

import { Similarities } from './Similarities';

export const SimilaritiesPage = () => {
  useTitle('Разрешение совпадений');

  return (
    <Layout withFooter>
      <Similarities />
    </Layout>
  );
};
